import { render, staticRenderFns } from "./result-target.vue?vue&type=template&id=5bc1af3e&"
import script from "./result-target.vue?vue&type=script&lang=js&"
export * from "./result-target.vue?vue&type=script&lang=js&"
import style0 from "./result-target.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports